import { render, staticRenderFns } from "./ADMBAT01M01.vue?vue&type=template&id=6609a160&"
import script from "./ADMBAT01M01.vue?vue&type=script&lang=js&"
export * from "./ADMBAT01M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports